// src/routes/RouteGuards.js
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../shared/hooks/useAuth';
import { useWarmupTimer } from '../shared/hooks/useWarmupTimer';
import Loading from '../shared/components/Loading';

export const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuth();
    const { isWarmup } = useWarmupTimer(isLoading);


    if (isLoading) return <Loading isWarmup={isWarmup} />;
    if (!isAuthenticated) return <Navigate replace to="/login" />;

    return children;
};

export const PublicRoute = ({ children }) => {
    const { isLoading } = useAuth();
    const { isWarmup } = useWarmupTimer(isLoading);


    if (isLoading) return <Loading isWarmup={isWarmup} />;

    return children;
};

const routeGuardProps = {
    children: PropTypes.node.isRequired
};

ProtectedRoute.propTypes = routeGuardProps;
PublicRoute.propTypes = routeGuardProps;
